<template>
  <div>
    <el-dialog
      :close-on-click-modal="false" :visible.sync="dialogVisible" width="40%" top="0vh"
      :center="true" @close="cancel">
      <template slot="title">
        <div style=" font-size: 18px; font-weight: bold; color: #333333">变更布控状态</div>
      </template>
      <el-form label-position="top" label-width="100px" :rules="boxrules" :model="boxruleForm" ref="boxForm">
        <div class="Publishtask_center">
          <div class="Publishtask_title">
            <el-form-item label="执行方式" class="item_form" prop="parentId">
              <el-radio-group @change="changeTheme" v-model="boxruleForm.parentId">
                <el-radio label="1">定时执行</el-radio>
                <el-radio label="2">立即执行</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="Publishtask_center">
            <div class="Publishtask_title" v-if="timedstart">
              <el-form-item label="执行时间设置" prop="dataTimer">
                <el-date-picker
                  v-model="boxruleForm.dataTimer"
                  type="datetimerange"
                  @change="dateChangebirthday"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00','23:59:59']"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="Publishtask_button">
          <el-button type="primary" @click="boxSave">确认</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getGateMessage } from '../api/main'

export default {
  name: 'openwindowone',
  data () {
    return {
      dialogVisible: false,// 打开窗口
      boxrules: {
        dataTimer: [ // 定时执行时间
          {
            required: true,
            message: '请选择执行时间 ',
            trigger: 'blur'
          }
        ],
        parentId: [ // 定时执行 还是 审批之后执行
          {
            required: true,
            message: '请选择所属分组',
            trigger: 'change'
          }
        ],
      },
      boxruleForm: {
        parentId: '', // 定时执行 还是 审批之后执行
        dataTimer: '', // 定时执行时间
        type: 1, // 操作类型
        gateType: null,
        operationFront: null, // 操作前状态
        dataTimer1: '',
      },
      gateOption: null, // 闸门列表
      timedstart: false, //
      sluicegate: null, // 闸门id
    }
  },
  methods: {
    // 打开弹窗
    open (data, index, siteId, status) {
      this.boxruleForm.gateType = index // 操作类型 4开启布控 5关闭布控
      this.boxruleForm.siteId = siteId
      this.boxruleForm.operationFront = status
      this.dialogVisible = true

    },
    // 获取定时执行还是审批之后立即执行
    changeTheme (val) {
      if (val == 1) {
        this.timedstart = true
      } else {
        this.timedstart = false
      }
    },
    // 切换闸门
    cutGate (value) {
      // this.gateShow
      const id = value
      // 获取闸门 num
      for (const i of this.options) {
        if (i.id === id) {
          this.num = i.num
          i.num > 5 ? (this.gateShow = false) : (this.gateShow = true)
        }
      }
      this.getGateVoice()
      // 切换闸门信息
      getGateMessage({
        id,
        size: this.size,
        page: 1,
        num: this.num,
        siteId: this.siteId,
      }).then((res) => {
        this.gateVo = {}
        this.gateVo = res.data.gateVo
        // 每次重新清空
        this.videoList = res.data.videoInfo.list[0]
        this.total = res.data.videoInfo.total
        this.pageSize = res.data.videoInfo.pageSize
        setTimeout(() => {
          const video = document.querySelector('#videoList')
          if (video) {
            video.innerHTML = ''
            new this.$ezuikit.EZUIKitPlayer({
              autoplay: true,
              id: 'videoList',
              header: ['capturePicture', 'save'],
              footer: ['hd', 'fullScreen'],
              accessToken: this.videoList.accessToken,
              url: this.videoList.videoAddress,
              template: 'simple',
              audio: 0,
            })
          }
        }, 500)
      })
    },
    // 取消
    cancel () {
      this.$refs.boxForm.resetFields()
      this.boxruleForm = {}
      // this.boxruleForm.parentId = ''
      this.dialogVisible = false
      this.timedstart = false
    },
    // 保存提交申请
    boxSave () {
      this.$refs.boxForm.validate((val) => {
        if (val) {
          let params = {
            carryOutTime: this.boxruleForm.dataTimer1, // 执行时间
            carryOutType: this.boxruleForm.parentId, // 执行类型
            gateType: this.boxruleForm.gateType, // 操作类型
            operands: '远程值守', // 操作对象
            operationFront: this.boxruleForm.operationFront, // 操作前的状态
            siteId: this.boxruleForm.siteId,// 当前站点id
            type: 2, // 变更布控状态
            // gateId: this.boxruleForm.sluicegate, // 闸门id
          }
          this.$axios.post(`/applyRecord/insertApplyRecord`, params).then((res) => {
            if (res.code == 200) {
              this.$message.success({ message: '执行成功，等待设备响应' })
              this.cancel()
              this.timedstart = false
            }
          })
        }
      })

    },
    // 获取时间
    dateChangebirthday (val) {
      this.boxruleForm.dataTimer1 = val[0] + ',' + val[1]
    },
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-date-editor.el-range-editor.el-input__inner {
  width: 380px;
  text-align: center;
}

/deep/ .el-date-editor .el-input__inner {
  border: 1px solid #DCDFE6 !important;
  width: 110% !important;
}

/deep/ .el-range-input {
  padding-left: 20px;
  text-align: center;
}

/deep/ .el-date-editor .el-input__icon {
  left: 0px !important;
  bottom: -1px;
}

/deep/ .el-date-editor .el-input__suffix {
  display: none !important;
}

/deep/ .el-dialog .el-dialog__body .el-form-item__error {
  left: 0px !important;
}

.Publishtask_center {
  //display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  .Publishtask_title {
    padding-top: 10px;
    width: 300px;

    /deep/ .el-form-item {
      width: 100% !important;
      margin: 10px !important;

      .el-form-item__content {
        .el-cascader {
          width: 100%;
        }

        /deep/ .el-form-item__error {
          left: 0 !important;
        }
      }
    }
  }

  .Publishtask_textarea {
    padding-top: 10px;
    width: 100%;
  }
}

.Publishtask_button {
  padding-top: 20px;
  display: flex;
  justify-content: center;
}


</style>
